import { all } from "redux-saga/effects";
import getBannerSaga from "./getBanner";

export default function* homepageSaga() {
  yield all([getBannerSaga()]);
}
